import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/steam-symbol': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zM448 177.7c0 63-51 113.8-113.7 113.8l-109.3 79.8c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67l-57.5-23.1v-107.3l97.2 39.3c15.1-9.2 32.2-13.3 52-11.5l71-101.7c0.5-62.3 51.5-112.8 114-112.8 62.8 0 113.8 51 113.8 113.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 0.5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zM410.5 177.7c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9 0.1 76.2-33.9 76.2-76.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/steam-symbol.js
// module id = 1036
// module chunks = 0